export const getFetchCalendarUrl = ({ therapistId }: { therapistId: string }) =>
  `therapists/${therapistId}/calendar`;
